import { render, staticRenderFns } from "./SyntheticMediaBarTitle.vue?vue&type=template&id=342e9b80&scoped=true"
import script from "./SyntheticMediaBarTitle.vue?vue&type=script&lang=js"
export * from "./SyntheticMediaBarTitle.vue?vue&type=script&lang=js"
import style0 from "./SyntheticMediaBarTitle.vue?vue&type=style&index=0&id=342e9b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342e9b80",
  null
  
)

export default component.exports